import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	iconLinkAriaLabel: {
		id: 'fastshift.common.migration-tickets-card.icon-link-aria-label',
		defaultMessage: 'Open MOVE ticket',
		description: 'Aria label for the icon link button',
	},
});
